// Account Name is valid
export const isValidAccountName = (name) => {
    return name && (/^[a-zA-Z0-9 -.\&\*]*$/.test(name)) ? true : false;
};

// Account Number is valid
export const isValidAbn = (abn) => {
    return !abn || abn.match(/^\d{2}[ ]\d{3}[ ]\d{3}[ ]\d{3}$/g) ? true : false;
}